module.exports = __webpack_public_path__ + "static/media/percentage.a83d58aa.svg";